import { lazy } from 'react';
const manifest = {
	CKFinder: lazy(() => import('./CKFinder')),
};

export default manifest;
